import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';

@Component({
  selector: 'app-designation-duty-combo-detail',
  standalone: true,
  imports: [CommonModule, DataTablesModule],
  templateUrl: './designation-duty-combo-detail.component.html',
  styleUrl: './designation-duty-combo-detail.component.scss'
})
export class DesignationDutyComboDetailComponent {

  isDisabled : boolean = false;
  @Input() DesignationDutyCombo = [] as any;
  @Input() SiteName = '';
  constructor(
    private activeModal: NgbActiveModal
  ){}

  ngOnInit(){
    this.initializeComboTable('#comboTable', this.DesignationDutyCombo);
  }

  close() {
    this.activeModal.close()
  }

  initializeComboTable(selector: string, data: any[]) {

    const tableElement = $(selector);

    if (tableElement.length === 0) {
      console.error(`Table ${selector} not found`);
      return;
    }

    // ✅ Proper destroy (ONLY ONCE)
    if ($.fn.dataTable.isDataTable(selector)) {
      $(selector).DataTable().clear().destroy();
      $(selector).empty();
      $(selector).off();
    }

    // ✅ define columns
    const columns = [
      {
        title: '#',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          return `<strong>${meta.row + 1}</strong>`;
        }
      },
      {
        title: 'Designation',
        data: 'DesignationName'
      },
      {
        title: 'Duty',
        data: 'DutyName'
      }
    ];

    // ✅ initialize ONLY ONCE
    $(selector).DataTable({
      data: data,
      columns: columns,
      paging: true,
      searching: true,
      ordering: true,
      autoWidth: false
    });
  }

}